import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'queDate',
  standalone: true
})
export class QueDatePipe implements PipeTransform {
  datePipe = inject(DatePipe);

  transform(
    value: Date | string | undefined | null,
    format?: string | null
  ): string | null {
    if (!value) return null;

    // An empty/falsy format (e.g. formatDate === '') should fall back to the
    // default, not be passed through as-is - Date/DatePipe treat '' as an
    // explicit (invalid) pattern rather than "unset".
    const effectiveFormat = format || 'dd/MM/yyyy';

    if (typeof value === 'string' && value.includes('T') && value.endsWith('Z')) {
      const date = new Date(value);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      if (effectiveFormat === 'MM/dd/yyyy') {
        return `${month}/${day}/${year}`;
      }

      if (effectiveFormat === 'dd/MM/yyyy') {
        return `${day}/${month}/${year}`;
      }

      return `${month}/${year}`;
    }

    // 'YYYY/MM' is a stored config value used elsewhere as a semantic flag (month-year
    // mode) - it isn't a valid DatePipe pattern. Angular's DatePipe now throws on
    // uppercase 'Y' (ISO week-year) where a calendar year was actually meant; normalize
    // to lowercase 'y' only for the actual formatting step, leaving the flag value
    // itself untouched everywhere else it's compared against.
    const normalizedFormat = effectiveFormat.replace(/Y+/g, (match) => match.toLowerCase());

    return this.datePipe.transform(value, normalizedFormat);
  }
}